import { BrowserRouter, Routes, Route } from "react-router-dom";
import CookieConsent from "./components/CookieConsent";
import WhatsAppFloat from "./components/WhatsAppFloat";
import DemoFloat from "./components/DemoFloat";
import DemoModal from "./components/DemoModal";
import RouteTracker from "./components/RouteTracker";
import Home from "./pages/Home";
import CrmIncorporadoras from "./pages/CrmIncorporadoras";
import CrmLoteadoras from "./pages/CrmLoteadoras";
import SistemaLoteamento from "./pages/SistemaLoteamento";
import CrmParaLoteamentos from "./pages/CrmParaLoteamentos";
import ErpFinanceiroLoteamentos from "./pages/ErpFinanceiroLoteamentos";
import MelhorCrmLoteamentos from "./pages/MelhorCrmLoteamentos";
import MelhorCrmIncorporadoras from "./pages/MelhorCrmIncorporadoras";
import CrmConstrutoras from "./pages/CrmConstrutoras";
import ErpFinanceiro from "./pages/ErpFinanceiro";
import SplitComissoes from "./pages/SplitComissoes";
import Autovendas from "./pages/Autovendas";
import Integracoes from "./pages/Integracoes";
import AgendarDemo from "./pages/AgendarDemo";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import TermosDeUso from "./pages/TermosDeUso";
import Lgpd from "./pages/Lgpd";
import Conteudo from "./pages/Conteudo";
import BlogPost from "./pages/BlogPost";
import Funcionalidades from "./pages/Funcionalidades";
import FuncionalidadeDetalhe from "./pages/FuncionalidadeDetalhe";
import NotFound from "./pages/NotFound";

// Descomente conforme for criando as páginas:
// import PlantaoDigital from "./pages/PlantaoDigital";
// import EstandeOnline from "./pages/EstandeOnline";
// import LancamentosImobiliarios from "./pages/LancamentosImobiliarios";
// import WhatsappIA from "./pages/WhatsappIA";
// import AssinaturaDigital from "./pages/AssinaturaDigital";

export default function App() {
  return (
    <BrowserRouter>
      <RouteTracker />
      <Routes>
        {/* ── HOME ── */}
        <Route path="/" element={<Home />} />

        {/* ── SOLUÇÕES ── */}
        <Route path="/crm-incorporadoras"         element={<CrmIncorporadoras />} />
        <Route path="/crm-loteadoras"              element={<CrmLoteadoras />} />
        <Route path="/sistema-para-loteamento"     element={<SistemaLoteamento />} />
        {/* Landing de SEO (não linkada no menu) — termo "crm para loteamentos" */}
        <Route path="/crm-para-loteamentos"        element={<CrmParaLoteamentos />} />
        <Route path="/crm-construtoras"            element={<CrmConstrutoras />} />
        {/* <Route path="/plantao-digital"            element={<PlantaoDigital />} /> */}
        <Route path="/gestao-de-recebiveis"              element={<ErpFinanceiro />} />
        {/* Landing de SEO (não linkada no menu) — termo "ERP financeiro loteamento" */}
        <Route path="/erp-financeiro-loteamentos"        element={<ErpFinanceiroLoteamentos />} />
        {/* Landings de SEO (não linkadas no menu) — termo "melhor CRM ..." */}
        <Route path="/melhor-crm-para-loteamentos"       element={<MelhorCrmLoteamentos />} />
        <Route path="/melhor-crm-para-incorporadoras"    element={<MelhorCrmIncorporadoras />} />
        <Route path="/split-comissoes"             element={<SplitComissoes />} />
        <Route path="/autovendas"                  element={<Autovendas />} />
        {/* <Route path="/lancamentos-imobiliarios"   element={<LancamentosImobiliarios />} /> */}
        {/* <Route path="/conversa-whatsapp"          element={<WhatsappIA />} /> */}

        {/* ── INTEGRAÇÕES ── */}
        <Route path="/integracoes"                element={<Integracoes />} />
        {/* <Route path="/assinatura-digital"         element={<AssinaturaDigital />} /> */}

        {/* ── CONVERSÃO ── */}
        <Route path="/agendar-demo"               element={<AgendarDemo />} />

        {/* ── LEGAL ── */}
        <Route path="/politica-de-privacidade"    element={<PoliticaPrivacidade />} />
        <Route path="/termos-de-uso"              element={<TermosDeUso />} />
        <Route path="/lgpd"                       element={<Lgpd />} />

        {/* ── FUNCIONALIDADES ── */}
        <Route path="/funcionalidades"            element={<Funcionalidades />} />
        <Route path="/funcionalidades/:slug"      element={<FuncionalidadeDetalhe />} />

        {/* ── BLOG / CONTEÚDO ──
            Listagem em /conteudo. Cada post fica na RAIZ (/{slug}) para preservar
            o SEO das URLs já indexadas no WordPress. A rota dinâmica :slug tem
            menor especificidade que as rotas estáticas acima, então elas vencem;
            BlogPost renderiza 404 se o slug não for um post. */}
        <Route path="/conteudo"                   element={<Conteudo />} />
        <Route path="/:slug"                      element={<BlogPost />} />

        {/* ── 404 (caminhos com múltiplos segmentos) ── */}
        <Route path="*"                           element={<NotFound />} />
      </Routes>

      <CookieConsent />
      <WhatsAppFloat />
      <DemoFloat />
      <DemoModal />
    </BrowserRouter>
  );
}
